<template>
  <div class="set-page">
    <h1 class="user-center-h1">{{$t('upgrade_page_layout_nav_53')}}</h1>
    <Tabs
      v-model="activePath"
      class="link-wrap"
      :options="linkList"
      @change="changePath"
    />
    <div >
    </div>
    <router-view/>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import Tabs from '@/components/Tabs'
export default {
  name: 'UserSet',
  components: {
    Tabs,
  },
  data() {
    const linkList = [
      {
        label: i18n.t('upgrade_page_views_user_set_index_766'),
        value: '/user-set/account',
      },
      {
        label: i18n.t('upgrade_page_views_user_set_index_767'),
        value: '/user-set/black',
      },
      {
        label: i18n.t('upgrade_page_views_user_set_index_768'),
        value: '/user-set/notice',
      },
    ]
    return {
      activePath: this.$route.path,
      linkList,
    }
  },
  created() {

  },
  methods: {
    changePath(path) {
      this.$router.replace({
        path
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .set-page {
    padding-bottom: 64px !important;
    overflow-y: auto;
    .link-wrap {
      margin-bottom: 28px;
    }
  }
</style>
